<div class="col-md-12 mb-30" *ngIf="Data_Change_Operaion_Id==-1">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Behfa Equipment Used for Instrument '{{inner_Kartable_Order_Interface.devicename}}'</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="inner_Kartable_Order_Interface.code2" disabled name="code2" class="form-control">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Instrument Code</label>
          <input [(ngModel)]="inner_Kartable_Order_Interface.code" disabled name="code" class="form-control">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Instrument Serial Number</label>
          <input [(ngModel)]="inner_Kartable_Order_Interface.serial" disabled name="serial" class="form-control">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Customer Name</label>
          <input [(ngModel)]="inner_Kartable_Order_Interface.customer" disabled name="customer" class="form-control">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Processing_Detail && inner_Can_Add_Edit" type="button" style="margin-right: 5px;"
            (click)="openModal_DeviceBehfa(templateDeviceBehfa)" class="btn btn-info left"> Add Behfa Equipment <i
              class="fa fa-building"></i> </button>

              <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-danger" style="margin-right: 5px;"><i
                class="fa   fa-file-excel-o"></i> Excel </button>

          <button *ngIf="!Processing_Detail" style="margin-right: 5px;" (click)="OnSet_Back_CalibrationList()"
            type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>

          <button *ngIf="Processing_Detail" type="button" class="btn btn-info" style="margin-right: 5px;"> Please wait...
            <i class="fa fa-spin fa-spinner"></i> </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>System ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Certificate No</th>
              <th>Cal due</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Calibration_Device">

              <tr>
                <td rowspan="2">{{DataList_Calibration_Device.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td class="EnglishClm">{{item.description}}</td>
                <td class="EnglishClm">{{item.manufacturer}}</td>
                <td class="EnglishClm">{{item.model}}</td>
                <td class="EnglishClm">{{item.codeBEHFA}}</td>
                <td>{{item.certificateNo}}</td>
                <td>{{item.calDueMiladi}}</td>

                <td class="EnglishClm">{{item.persianDate}}</td>
                <td >
                  <button *ngIf="!item.del && inner_Can_Add_Edit" type="button" (click)="openModal(template,item)"class="btn btn-danger">
                    <i class="fa fa-remove"></i> Delete
                  </button>

                  <button type="button" (click)="Set_Change_Operaion(item.id_temp)"class="btn btn-info">
                    <i class="fa  fa-building"></i> Equipment Details
                  </button>

                  <p *ngIf="item.del" style="color: red; font-weight: 600;">Deleted</p>
                </td>
              </tr>

              <tr>
                <td><b>Change Description</b></td>
                <td colspan="4">{{item.dsc}}</td>
                <td><b>Changed By</b></td>
                <td>{{item.fixer}}</td>
                <td><b>Change Date</b></td>
                <td>{{item.type}}</td>
              </tr>

            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #395a9b; color: white;">
            <tr>
              <th>#</th>
              <th>System ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Certificate No</th>
              <th>Cal due</th>
              <th>Start</th>
              <th>End</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Calibration_Device_Scan">

              <tr>
                <td rowspan="2">{{DataList_Calibration_Device_Scan.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td class="EnglishClm">{{item.description}}</td>
                <td class="EnglishClm">{{item.manufacturer}}</td>
                <td class="EnglishClm">{{item.model}}</td>
                <td class="EnglishClm">{{item.codeBEHFA}}</td>
                <td>{{item.certificateNo}}</td>
                <td>{{item.calDueMiladi}}</td>
                <td>{{item.changeDsc}}</td>
                <td>{{item.changeDate}}</td>

                <td>
                  <button type="button" (click)="Set_Change_Operaion(item.id_temp)"class="btn btn-info">
                    <i class="fa  fa-building"></i> Equipment Details
                  </button>
                </td>
              </tr>



            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-DeviceBehfaEdit
  [deviceBehfa_id_Innner]="Data_Change_Operaion_Id"
  (OnBack_DeviceBehfa_Edit_Action)="OnBack_Change_Operaion()"
  *ngIf="Data_Change_Operaion_Id>0">

</app-DeviceBehfaEdit>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>Description</th>
      <th></th>
      <th>Manufacturer</th>
      <th></th>
      <th>Model</th>
      <th></th>
      <th>ID</th>
      <th></th>
      <th>Certificate No</th>
      <th></th>
      <th>Cal due</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Calibration_Device">
      <td>{{item.description}}</td>
      <td></td>
      <td>{{item.manufacturer}}</td>
      <td></td>
      <td>{{item.model}}</td>
      <td></td>
      <td>{{item.codeBEHFA}}</td>
      <td></td>
      <td>{{item.certificateNo}}</td>
      <td></td>
      <td>{{item.calDueMiladi}} _</td>
    </tr>
    <tr *ngFor="let item of DataList_Calibration_Device_Scan">
      <td>{{item.description}}</td>
      <td></td>
      <td>{{item.manufacturer}}</td>
      <td></td>
      <td>{{item.model}}</td>
      <td></td>
      <td>{{item.codeBEHFA}}</td>
      <td></td>
      <td>{{item.certificateNo}}</td>
      <td></td>
      <td>{{item.calDueMiladi}} _</td>
    </tr>
  </tbody>
</table>


<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Approve Delete Equipment '{{Selected_Calibration_Device.codeBEHFA}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="DeviceBehfa_Delete_Dsc" name="DeviceBehfa_Delete_Dsc" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" [disabled]="!DeviceBehfa_Delete_Dsc"
      (click)="Delete(Selected_Calibration_Device)"> Delete <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]="inner_Persian_Date"
      [inner_SeletedDeviceBehfa]="DataList_Calibration_Device"
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>
